import { StrictMode } from 'react';

import * as ReactDOM from 'react-dom/client';
import { SWRConfig } from 'swr';

import { cookieJar, swrConfig, worker } from '@consumer-frontend/api';
import { OptimizelyWrapper } from '@consumer-frontend/optimizely';

import { App } from './app/App';
import { analytics } from './utils/adobe-analytics';
import './utils/datadog';

async function enableMocking() {
  if (
    import.meta.env.VITE_ENV === 'development'
    && import.meta.env.VITE_MOCKING === 'true'
  ) {
    await worker.start({
      // This disables reporting of unhandled requests. Cf: https://github.com/mswjs/msw/discussions/1589
      onUnhandledRequest: 'bypass',
    });
  }
}

enableMocking().then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );

  // Read synchronously out of the access-token JWT, so this adds no network wait.
  // The error arm is ignored: OptimizelyWrapper already degrades to bare children
  // when there is no id, which is the same outcome.
  const [accountId] = cookieJar.getAccountId();

  // Tags the FullStory session with the account ID. No traits: the Adobe plugin's identify
  // hook would copy them into window.analyticsDataLayer.
  if (accountId) analytics.identify(accountId);

  root.render(
    <StrictMode>
      <SWRConfig value={swrConfig}>
        <OptimizelyWrapper user={{ id: accountId }}>
          <App />
        </OptimizelyWrapper>
      </SWRConfig>
    </StrictMode>,
  );
});
